import { useNavigate, useLocation } from 'react-router-dom';
import { useSessionContext } from '@contexts';
import { DropdownSelect, DropdownOption, DropdownSelectCompactTrigger } from "@common";

const ResidentSelector = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { accounts, changeSelectedResident, selectedAccount } = useSessionContext();

    if (!selectedAccount) return null;

    const changeResident = (idAccount: number) => {
        if (idAccount === selectedAccount.idAccount) return;
        changeSelectedResident(idAccount, navigate, location.pathname, {
            ensureCommunitySubdomain: true,
            replace: true
        });
    };

    // Show static text when only one account
    if (accounts.length <= 1) {
        return (
            <p className="text-xs leading-4 text-neutral-600 tracking-[0.12px]">
                For {selectedAccount.residentName}
            </p>
        );
    }

    return (
        <div className="flex items-center gap-2">
            <span className="text-xs leading-4 text-neutral-600 tracking-[0.12px]">For</span>
            <DropdownSelect
                trigger={DropdownSelectCompactTrigger}
                value={selectedAccount.idAccount}
                onChange={changeResident}
            >
                {accounts.map(account => (
                    <DropdownOption key={account.idAccount} value={account.idAccount}>
                        {account.residentName}
                    </DropdownOption>
                ))}
            </DropdownSelect>
        </div>
    );
};

export default ResidentSelector;
